var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkMen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17599 7.95884C1.19699 7.93848 1.22374 7.90877 1.25297 7.87865C1.26038 7.87091 1.28138 7.8469 1.2892 7.83957C1.3353 7.79602 1.30072 7.82532 1.35671 7.78584C1.69962 7.31488 1.39211 5.79577 2.02401 5.27393L2.61886 4.78547C2.61886 4.72522 2.60404 4.73743 2.66414 4.75046L2.78764 4.6605L2.74647 4.80216C2.74935 5.01341 2.44802 6.27894 2.36733 6.66197C2.25289 7.20376 2.2002 7.08653 2.62627 7.71298C2.74112 7.8819 2.82592 8.01257 2.92595 8.17864C3.59202 9.28623 4.54748 10.7028 5.28723 11.8596C5.4346 12.09 5.72194 12.6086 5.89813 12.7775C6.43988 13.2969 7.66415 12.7742 6.91575 11.6614C6.16736 10.5485 5.3074 9.12422 4.56147 7.97512C4.20539 7.42641 4.20827 7.64296 4.37046 6.90457C4.42604 6.6522 4.5623 5.83281 4.65492 5.67324C4.86034 6.07419 4.89657 6.29074 5.25471 6.52887L7.2352 7.46793C7.6732 7.65273 8.09516 7.32017 7.98113 6.87771C7.87451 6.46537 6.73092 6.17066 6.12496 5.81286C5.57621 5.48926 5.57704 4.76552 5.17526 3.85373C5.03159 3.52646 4.81876 3.14871 4.53883 3.03271C4.14611 2.86988 3.64389 2.92117 3.25693 3.0498C2.54558 3.28548 2.09029 3.82483 1.5329 4.24368C0.574146 4.96498 0.680355 5.09971 0.542037 6.17066C0.436652 6.98761 0.0418712 8.19452 1.17599 7.95884Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23807 8.44201C2.17221 8.44201 2.18744 8.45707 2.19938 8.39112L2.18003 8.33739C2.10387 8.29384 2.17015 8.31134 2.05036 8.31012C2.03183 8.60401 1.74655 9.45109 1.65352 9.79789C1.54319 10.2078 0.377785 11.5299 0.0896237 12.0204C-0.213357 12.5369 0.303686 13.1434 0.866013 12.9696C1.15047 12.8817 1.367 12.5308 1.56748 12.2496L2.57934 10.8937C2.78228 10.6429 2.79299 10.6364 2.89467 10.266C3.18736 9.20238 3.1606 9.77388 2.23807 8.44201Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42398 0.0302969C3.82214 0.162995 3.3018 0.723505 3.44094 1.47981C3.74021 3.10801 6.22828 2.64194 5.92283 1.01048C5.81168 0.416181 5.18184 -0.137001 4.42398 0.0302969Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkMen);
export default __webpack_public_path__ + "static/media/walkMen.40e4d876312a14d2846885f9e6ced8b5.svg";
export { ForwardRef as ReactComponent };